// extracted by css-extract-rspack-plugin
export default {"Pagehead":"YourSponsorships-module__Pagehead__DNo99","Text":"YourSponsorships-module__Text__Jx_aG","UnderlineNav":"YourSponsorships-module__UnderlineNav__M7IY6"};